<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- GO BACK BUTTON -->
<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="goBack()"></button>
    </ng-template>
</p-toolbar>

<p-fieldset>

    <!-- HEADER -->
    <ng-template pTemplate="header">Ingrese los campos requeridos y presione Guardar/Actualizar</ng-template>

    <!-- MAIN SCREEN -->
    <div class="card" *ngIf="translations && globalUserPreferences?.storeId != null">

        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <p-panel>
                    <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">
                        <!-- INPUT COORDINACIÓN ID -->
                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_coordination}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedCoordination').value}}</span>
                        </div>


                        <!-- INPUT CURRENCIES -->
                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_currency}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedCurrency').value?.value}}</span>
                        </div>

                        <!-- INPUT DETAIL -->
                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_concept}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedConcept').value}}</span>
                        </div>

                        <!-- INPUT ID REGISTRO -->
                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_id}} {{translations.lbl_record}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedIdRegister').value}}</span>
                        </div>
                    </div>
                </p-panel>
            </div>
            <div class="p-col-12 p-md-6">
                <p-panel>
                    <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">
                        <!-- INPUT ACCOUNT -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                            [ngClass]="{ 'invalid-input': globalUserDataForm.get('selectedDocument').invalid && (globalUserDataForm.get('selectedDocument').dirty || globalUserDataForm.get('selectedDocument').touched) }">

                            <div class="subTitle p-col-12 p-md-4">
                                <span>#{{translations.lbl_document_id}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input type="text" pInputText formControlName="selectedDocument"
                                    placeholder="{{translations.lbl_entry}} {{translations.lbl_document_id}}">
                            </div>
                        </div>

                        <!-- INPUT DATE -->
                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_date}}</span>
                            <div class="p-col-12 p-md-8">
                                <p-calendar formControlName="selectedDate" [touchUI]="true" [readonlyInput]="true"
                                    inputId="touchui" [showIcon]="true" dateFormat="dd-mm-yy" [disabled]="false" placeholder="{{translations.lbl_select}} {{translations.lbl_date}}"
                                    [minDate]="globalUserDataForm.get('selectedMinDate').value"
                                    [maxDate]="globalUserDataForm.get('selectedMaxDate').value"></p-calendar>
                            </div>
                        </div>
                        <!-- INPUT IMPORTE -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                            [ngClass]="{ 'invalid-input': globalUserDataForm.get('selectedAmount').invalid && (globalUserDataForm.get('selectedAmount').dirty || globalUserDataForm.get('selectedAmount').touched) }">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_amount}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <p-inputNumber placeholder="Ingrese una cantidad" formControlName="selectedAmount"
                                    mode="decimal" [showButtons]="true" inputId="minmax-buttons" [minFractionDigits]="2"
                                    [maxFractionDigits]="2" [locale]="'es-MX'"></p-inputNumber>
                            </div>
                        </div>

                        <!-- INPUT ACCOUNT -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_comments}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input type="text" pInputText formControlName="selectedComments"
                                    placeholder="{{translations.lbl_entry}} {{translations.lbl_comments}}">
                            </div>
                        </div>

                    </div>
                </p-panel>
            </div>
        </div>
        <!-- BUTTONS SECTION-->
        <div class="p-grid">
            <div class="p-xl-6 p-lg-12 p-md-12 p-sm-12 p-xs-12"></div>
            <div class="p-xl-6 p-lg-12 p-md-12 p-sm-12 p-xs-12">
                <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                    <div class="p-col-12 p-md-6">
                        <button style="width: 100% !important;" *ngIf="dataParent.opt === 'update'" pButton pRipple
                            type="button" icon="pi pi-times" label="Eliminar" class="p-button-raised p-button-danger"
                            (keyup.enter)="deleteRecPay($event)" (click)="deleteRecPay($event)"
                            [disabled]="!globalUserDataForm.valid"></button>
                    </div>

                    <div class="p-col-12 p-md-6">
                        <button style="width: 100% !important;" pButton pRipple type="button" icon="pi pi-plus"
                            [label]="dataParent.opt === 'update' ? translations.lbl_update : translations.lbl_save"
                            class="p-button-raised p-button-success" (keyup.enter)="saveRecPay($event)"
                            (click)="saveRecPay($event)" [disabled]="!globalUserDataForm.valid"></button>
                    </div>
                </div>

            </div>
        </div>
    </div>

</p-fieldset>


<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferences?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>